import * as types from 'model/actionTypes'
import { DictT, SupplierT } from 'shared/types/model'

export function receiveSuppliers (suppliers: DictT<SupplierT>) {
  return {
    type: types.RECEIVE_SUPPLIERS,
    suppliers
  }
}
